import { render, staticRenderFns } from "./TextHero.vue?vue&type=template&id=7bc969c4"
import script from "./TextHero.vue?vue&type=script&lang=js"
export * from "./TextHero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports